import PropTypes from 'prop-types';
import { useState } from 'react';
import { toggleEnrolledCourse, toggleBookmarkItem } from '@actions/courses';
import PlusCourseCard from '@comp/PlusCourseCard/AquillaPlusCourseCard';
import FreeCourseCard from '@comp/FreeCourseCard/FreeCourseCard';
import { useDispatch } from 'react-redux';
import {
  getCourseEnrollMessage,
  programmeTypes,
  staticStrings
} from '@constants/index';
import Dynamic from '@base/Dynamic/Dynamic';
import useProfileFeed from '@api/hooks/profile/useProfileFeed';
import { useSnackbar } from '@stores/snackbar';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';
import useIsRecordedGoal from '@hooks/useIsRecordedGoal';

const Dialog = Dynamic(() => import('@comp/Dialog/Dialog'));

const CourseCard = ({
  courseUID,
  courseData = {},
  index,
  item,
  gridColumn,
  username,
  disabledTopicGroup,
  hideLessonCount,
  label
}) => {
  const courseID = courseUID || item.course;
  const [showUnenrollDialog, setShowUnenrollDialog] = useState(false);
  const dispatch = useDispatch();
  const { open: showSnackbar } = useSnackbar();

  const { mutate: refetchProfileFeed } = useProfileFeed(username);
  const selectedGoalUID = useSelectedGoalUID();
  const { uid: goalUID, name } = courseData.goal || {};

  const isRecordedGoal = useIsRecordedGoal(goalUID);

  const onClickSave = (isBookmarked) => {
    dispatch(toggleBookmarkItem(courseID, 4, isBookmarked));
  };

  const sendEvent = () => {};

  const onClickEnroll = async (courseIdentification, enroll) => {
    if (enroll) {
      setShowUnenrollDialog(true);
    } else {
      sendEvent('educatorProfile-courseEnroll');
      await dispatch(toggleEnrolledCourse(courseID, true));
      refetchProfileFeed();
      showSnackbar({
        message: getCourseEnrollMessage({
          type:
            courseData.programmeType === programmeTypes.TESTSERIES
              ? 'Test-series'
              : 'Course',
          goalName: name,
          goalUID,
          selectedGoalUID,
          isRecordedGoal
        }),
        type: 'success'
      });
    }
  };

  const onCloseUnenrollModal = () => setShowUnenrollDialog(false);

  const acceptOnClick = () => {
    sendEvent('educatorProfile-courseUnEnroll');
    dispatch(toggleEnrolledCourse(courseID, false));
    setShowUnenrollDialog(false);
    setTimeout(() => refetchProfileFeed(), 500);
  };

  if (courseData.forPlus || courseData.isSpecial) {
    return (
      <>
        <PlusCourseCard
          index={index}
          key={courseData.uid}
          course={courseData}
          toggleEnroll={onClickEnroll}
          dataAnalytics="educatorProfile"
          gridColumn={gridColumn}
          disabledTopicGroup={disabledTopicGroup}
          hideLessonCount={hideLessonCount}
          label={label}
        />
        <Dialog
          onClose={onCloseUnenrollModal}
          dialogState={showUnenrollDialog}
          heading="Are you sure you want to unenroll?"
          message={staticStrings.UNENROLL_MESSAGE}
          acceptLabel="Unenroll"
          rejectLabel="Cancel"
          acceptOnClick={acceptOnClick}
          rejectOnClick={onCloseUnenrollModal}
        />
      </>
    );
  }
  return (
    <FreeCourseCard
      index={index}
      key={courseData.uid}
      course={courseData}
      onClickSave={onClickSave}
      dataAnalytics="educatorProfile"
      gridColumn={gridColumn}
    />
  );
};

export default CourseCard;

CourseCard.propTypes = {
  courseUID: PropTypes.string,
  index: PropTypes.number.isRequired,
  item: PropTypes.objectOf(PropTypes.any),
  gridColumn: PropTypes.string,
  username: PropTypes.string,
  disabledTopicGroup: PropTypes.bool,
  hideLessonCount: PropTypes.bool
};

CourseCard.defaultProps = {
  courseUID: '',
  item: {},
  gridColumn: 'span 6',
  username: '',
  disabledTopicGroup: false,
  hideLessonCount: false
};
